news11.vue<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>에듀윌, (주)산타와 손잡고 에듀테크 속도 낸다</h4>
                            <div class="board_meta">
<!--                                <ul>-->
<!--                                    <li>등록일 : 22.05.24</li>-->
<!--                                    <li>조회수 : 142</li>-->
<!--                                </ul>-->
                            </div>
                        </div>
                      <div class="board_body">
                            <div class="board_content">
                                <figure class="image"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img_report_14.png"></figure>
                                <br>
                                <br>
                              종합교육기업 에듀윌(대표 양형남)이 지난 20일, 교육 솔루션기업 ㈜산타(대표 박기웅)와 에듀테크 ? AI 분야에서의 공동 사업 추진을 위한 전략적 제휴 협약(MOU)을 체결했다고 21일 밝혔다.
                              <br><br>
                              산타는 첨단 AI 기술을 활용한 교육 솔루션을 제공하는 기업으로, 성인 교육시장에서 차별화된 학습관리시스템(LMS)과 AI 기반의 맞춤형 교육 콘텐츠를 선보이고 있다.
                              <br><br>
                              이날 협약식은 서울 구로구 에듀윌 본사에서 양형남 에듀윌 대표와 박기웅 산타 대표를 포함해 양사 주요 관계자들이 참석한 가운데 진행됐다.
                              <br><br>
                              이번 MOU 체결은 성인 교육시장을 대상으로 한 AI 기반 교육 솔루션 및 LMS 서비스 분야에서 양사의 경쟁력을 극대화하고, 상호간 기업 가치를 제고하기 위함이라는 게 에듀윌의 설명이다. 
                              <br><br>
                              이를 위해 양사는 적극적인 상호 협력을 바탕으로 글로벌 진출과 신사업 개발을 목표로 하는 전략적 파트너십을 강화해 나갈 방침이다. 그 첫 단계로 연내 산타의 기술력이 적용될 수 있는 자격증 론칭을 시범적으로 시도해 본다는 계획이다.
                              <br><br>
                              에듀윌과 산타는 교육 콘텐츠와 솔루션 서비스 분야에서도 상호 협력하기로 했다. 특히 교육기관 및 지자체의 교육 인프라 구축사업에 참여, 신규 브랜드 론칭을 위한 기술 지원에 공동으로 나설 예정이다.
                              <br><br>
                              에듀윌 양형남 대표는 "이번 협약을 통해 양사가 보유한 강점을 극대화해 혁신적인 교육 솔루션을 제공하고, 에듀테크 및 AI 교육 시장에서 새로운 기회를 모색할 수 있을 것으로 기대한다"고 말했다. 
                              <br><br>
                              이에 산타의 박기웅 대표는 "에듀윌과의 지속적인 협력을 통해 AI 기반의 차세대 교육 솔루션을 선보일 것”이라며, “단순한 협약을 넘어 양사가 시너지를 내며 성장하길 바란다"라고 전했다.
                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news15" data-value="315283">
                                        <strong>이전</strong>
                                        <span>에듀윌, ‘완성형 에듀테크 클러스터’ 조성에 박차</span>
                                    </router-link>
                                </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                              <!-- 다음 보도 기사가 있을 경우 -->
                              <li class="next">
                                <router-link to="/edu/newsRelease/promotionVideo/news13" data-value="315283">
                                  <strong>다음</strong>
                                  <span>에듀윌, 케이잡스와 상호 협력 및 파트너십 구축을 위한 업무협약 체결</span>
                                </router-link>
                              </li>
                              <!-- //다음 보도 기사가 있을 경우 -->

                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
